import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M31.41 60C32.13 60 32.842 59.975 33.549 59.927C35.177 58.178 36.594 56.26 37.813 54.197C35.767 54.72 33.623 55 31.41 55C17.415 55 6.068 43.807 6.068 30C6.068 16.193 17.415 5 31.411 5C41.484 5 50.185 10.798 54.271 19.196C55.809 18.503 57.394 17.851 58.933 17.222C54.069 7.044 43.573 0 31.41 0C14.615 0 1 13.431 1 30C1 46.569 14.615 60 31.41 60Z",
      fill: "url(#loadingGradient)"
    }, null, -1),
    _createElementVNode("defs", null, [
      _createElementVNode("linearGradient", {
        id: "loadingGradient",
        x1: "38.1148",
        y1: "51.9816",
        x2: "46.3623",
        y2: "8.04971",
        gradientUnits: "userSpaceOnUse"
      }, [
        _createElementVNode("stop", {
          "stop-color": "#1D3E73",
          "stop-opacity": "0"
        }),
        _createElementVNode("stop", {
          offset: "1",
          "stop-color": "#265399"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }